import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Badge extends React.Component
{
    static propTypes = {
        small: PropTypes.bool,
        colour: PropTypes.oneOf([
            'gray',
            'red',
            'orange',
            'yellow',
            'green',
            'teal',
            'blue',
            'indigo',
            'purple',
            'pink'
        ]),
    };

    static defaultProps = {
        small: false,
        type: 'plain'
    };

    render()
    {
        const { small, colour } = this.props;

        const classes = classNames(
            'inline-flex items-center px-2.5 py-0.5 rounded',
            this.props.className,
            {
                'text-xs font-medium leading-4': small,
                'text-sm font-medium leading-5': ! small,
            },
            {
                'bg-gray-200 border-gray-200 text-gray-800': ! colour || colour === 'gray',
                'bg-red-100 border-red-200 text-red-800': colour === 'red',
                'bg-orange-100 border-orange-200 text-orange-800': colour === 'orange',
                'bg-yellow-100 border-yellow-200 text-yellow-800': colour === 'yellow',
                'bg-green-100 border-green-200 text-green-800': colour === 'green',
                'bg-teal-100 border-teal-200 text-teal-800': colour === 'teal',
                'bg-blue-100 border-blue-200 text-blue-800': colour === 'blue',
                'bg-indigo-100 border-indigo-200 text-indigo-800': colour === 'indigo',
                'bg-purple-100 border-purple-200 text-purple-800': colour === 'purple',
                'bg-pink-100 border-pink-200 text-pink-800': colour === 'pink'
            }
        );

        return <span className={classes}>
            { this.props.children }
        </span>;
    }
}
